import * as React from 'react';
import styled from 'styled-components';


const Wrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: relative;
  padding: 0 0 45px;
  min-height: 100vh;
  z-index: 1;
`;

const Title = styled.h2`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 105px 25px 35px;
  width: 160px;
  min-height: 176px;
  font-size: 18px;
  font-weight: bold;
  background: url(${require('../../assets/location/title_bg@2x.png')}) 0 0 no-repeat;
  background-size: 160px;
  text-align: center;
`;

const Section = styled.div`
  display: block;
  margin-top: 40px;
  width: 100%;
`;

const SubWrap = styled.div`
  padding: 30px 25px;
`;

const SubSec = styled.div`
  margin-top: 30px;
  padding-bottom: 20px;
  border-bottom: 1px solid #fff8e4;
  text-align: center;
  &:first-child {
    margin-top: 0;
  }
  & h2 {
    font-size: 16px;
    font-weight: bold;
  }
  .contents {
    margin-top: 10px;
    line-height: 1.6;
    color: #a8988a;
  }
`;

interface IProps {
  messages?: any;
}

const { RenderAfterNavermapsLoaded, NaverMap, Marker } = require('react-naver-maps');


const Location = ({messages} : IProps) => {
  const { locations } = messages;
  return (
    <Wrap>
      <Title>Location</Title>
      <Section>
        <RenderAfterNavermapsLoaded clientId={'zzevfavlv8'} ncpClientId={'zzevfavlv8'} error={<p>Maps Load Error</p>}
  loading={<p>Maps Loading...</p>}>
          <NaverMap 
            id='maps-examples-map-simple'
            style={{ width: '100%', height: '250px' }}
            defaultCenter={{ lat: 37.5060362, lng: 127.0645343 }}
            defaultZoom={11}>
            <Marker 
              position={{ lat: 37.5060362, lng: 127.0667343 }}
              onClick={() => {
                alert('')
              }}
            />
          </NaverMap>
        </RenderAfterNavermapsLoaded>
        <SubWrap>
          <SubSec>
            <h2>{locations.address}</h2>
            <div className="contents">
              <address dangerouslySetInnerHTML={ {__html: locations.addressContent} } />
            </div>
          </SubSec>
          <SubSec>
            <h2>{locations.subway}</h2>
            <div className="contents">
              <p dangerouslySetInnerHTML={ {__html: locations.subwayContent} } />
            </div>
          </SubSec>
          <SubSec>
            <h2>{locations.bus}</h2>
            <div className="contents">
              <p dangerouslySetInnerHTML={ {__html: locations.busContent} } />
            </div>
          </SubSec>
        </SubWrap>
      </Section>
    </Wrap>
  );
}

export default Location;


// WEBPACK FOOTER //
// ./src/components/location/index.tsx